import BaseRestApi from '@/services/BaseRestApi';
import ImpotSourceDto from '@/models/calculette/ImpotSourceDto';
import SimulationDto from '@/models/SimulationDto';
import RestErreur from '@/utils/RestErreur';
import PdfUtils from '@/utils/PdfUtils';

export default class ImpotSourceRestApi extends BaseRestApi {
  get resource() { // eslint-disable-line
    return '/is';
  }

  /**
   * Calcule l'impôt dû
   * @param impotSourceDto Données du contribuable
   * @return {Promise<ImpotSourceDtoDto|RestErreur>}
   */
  async calculerImpot(impotSourceDto) {
    try {
      const coAnswer = await this.getApi().post(`${this.resource}/calculImpotSalarie`, impotSourceDto);
      const ciStatus = coAnswer.status;

      if (ciStatus === 200) {
        if (coAnswer.data) {
          // return ImpotSourceDto.jsonToList(coAnswer.data, ImpotSourceDto.getFactory);
          return ImpotSourceDto.getFactory(coAnswer.data);
        }
        return new RestErreur("Erreur lors de l'appel /calculImpotSalarie", coAnswer);
      }
      return new RestErreur('Rest api:calculerImpot() warning', coAnswer);
    } catch (inexError) {
      return new RestErreur('Rest api:calculerImpot() erreur', inexError);
    }
  }

  /**
   * Génération du pdf annonce
   * @param indtoImpot Données du contribuable
   * @return {Promise<string|RestErreur>} ouvre le pdf dans une autre fenêtre
   */
  async getPdf(indtoImpot) {
    try {
      const coAnswer = await this.getApi().post(`${this.resource}/pdfAnnonce`, indtoImpot, { responseType: 'blob' });
      const ciStatus = coAnswer.status;

      if (ciStatus === 200) {
        if (coAnswer.data) {
          return await PdfUtils.showPDF(coAnswer);
        }
        return new RestErreur(`Pas de pdf pour ce contribuable: ${indtoImpot}`, coAnswer);
      }
      return new RestErreur('Rest api:getPdf() warning', coAnswer);
    } catch (inexError) {
      return new RestErreur('Rest api:getPdf() erreur', inexError);
    }
  }

  async genererPdf(contribuableIsDto) {
    try {
      const coAnswer = await this.getApi().post(`${this.resource}/pdfAnnonce`, contribuableIsDto);
      // const coAnswer = await this.getApi().post(`${this.resource}/pdfAnnonce`, contribuableIsDto, { headers: { Accept: '*/*' } });
      const ciStatus = coAnswer.status;

      if (ciStatus === 200) {
        if (coAnswer.data) {
          const oBlob = new Blob([coAnswer.data], { type: 'application/pdf' });
          const sUrl = URL.createObjectURL(oBlob);
          window.open(sUrl, 'receivedPdf.pdf', 'width=1024,height=800');
          URL.revokeObjectURL(sUrl); // libère la mémoire
          // return coAnswer.data;
        }
        // return new RestErreur("Erreur lors de l'appel /pdfAnnonce", coAnswer);
      }
      return new RestErreur('Rest api barème warning', coAnswer);
    } catch (inexError) {
      return new RestErreur('Rest api bareme erreur', inexError);
    }
  }

  /**
   * Calcule l'impôt dû
   * @param impotSourceDto Données du contribuable
   * @return {Promise<ImpotSourceDtoDto|RestErreur>}
   */
  async determinerBaremeAjuste(simulationDto) {
    try {
      const coAnswer = await this.getApi().post(`${this.resource}/determinerBaremeAjuste`, simulationDto);
      const ciStatus = coAnswer.status;

      if (ciStatus === 200) {
        if (coAnswer.data) {
          return SimulationDto.getFactory(coAnswer.data);
        }
        return new RestErreur("Erreur lors de l'appel /determinerBaremeAjuste", coAnswer);
      }
      return new RestErreur('Rest api:determinerBaremeAjuste() warning', coAnswer);
    } catch (inexError) {
      return new RestErreur('Rest api:determinerBaremeAjuste() erreur', inexError);
    }
  }
}
